import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
import MainLayout from '../layouts/main';
import UserLayout from '../layouts/user';
import ReportLayout from '../layouts/report';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
    Page404,
    PageOne,
    PageTwo,
    PageSix,
    PageFour,
    PageFive,
    LoginPage,
    PageThree,
    SetUserPage,
    SetUserLoginPage,
    SetAllProjectAccessPage,
    EntLogin,
    ModuleRoleAccessListPage,
    ModuleRoleAccessListReport,
    ErrorPage,
    LoginSelection,
    DealerLogin
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
    return useRoutes([
        {
            path: '/',
            children: [
                { element: <Navigate to='loginselection' replace />, index: true },
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <SetUserLoginPage />
                        </GuestGuard>
                    ),

                },
                {
                    path: 'loginselection',
                    element: (
                        <GuestGuard>
                            <LoginSelection />
                        </GuestGuard>
                    ),

                },
                {
                    path: 'dealerlogin/oauth2_callback',
                    element: (
                        <GuestGuard>
                            < DealerLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'dealerlogin',
                    element: (
                        <GuestGuard>
                            < DealerLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'entlogin',
                    element: (
                        <GuestGuard>
                            < EntLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'allprojectsaccess',
                    element: (
                        <GuestGuard>
                            <SetAllProjectAccessPage />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'error/errorpage',
                    element: (
                        <GuestGuard>
                            <ErrorPage />
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: '/dashboard',
            element: (
                <AuthGuard>
                    <DashboardLayout />
                </AuthGuard>
            ),
            children: [
                { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
                { path: 'one', element: <PageOne /> },
                { path: 'two', element: <PageTwo /> },
                { path: 'three', element: <PageThree /> },
                {
                    path: 'user',
                    children: [
                        { element: <Navigate to="/dashboard/user/four" replace />, index: true },
                        { path: 'four', element: <PageFour /> },
                        { path: 'five', element: <PageFive /> },
                        { path: 'six', element: <PageSix /> },
                    ],
                },
            ],
        },
        {
            path: '/main',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
                /*  { path: 'one', element: <PageOne /> }, */
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/main/master/one" replace />, index: true },
                        { path: 'one', element: <PageOne /> },
                        { path: 'two', element: <PageTwo /> },
                        { path: 'three', element: <PageThree /> },
                        { path: 'four', element: <PageFour /> },
                        { path: 'five', element: <PageFive /> },
                        { path: 'six', element: <PageSix /> },
                    ],
                },
            ],
        },

        {

            path: '/user',
            element: (
                <GuestGuard>
                    <UserLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to="/user/user" replace />, index: true },
                { path: 'user', element: <SetUserPage /> },
                { path: 'moduleroleaccesslistpage', element: <ModuleRoleAccessListPage /> },
                { path: 'moduleroleaccesslistreport', element: <ModuleRoleAccessListReport /> },
            ],
        },

        {
            path: '/report',
            element: (
                <GuestGuard>
                    <ReportLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to="/report/moduleroleaccesslistreport" replace />, index: true },
                { path: 'moduleroleaccesslistreport', element: <ModuleRoleAccessListReport /> },
            ],
        },
        {
            element: <CompactLayout />,
            children: [{ path: '404', element: <Page404 /> }],
        },
        { path: '*', element: <Navigate to="/404" replace /> },
    ]);
}
